/* unplugin-vue-components disabled */import script from "./Service.vue?vue&type=script&setup=true&lang=js"
export * from "./Service.vue?vue&type=script&setup=true&lang=js"

import "./Service.vue?vue&type=style&index=0&id=5ea9d54e&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/pro-swan-h5-game/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ea9d54e"]])

export default __exports__